// extracted by mini-css-extract-plugin
module.exports = {"linkRow":"links_linkRow__1g_Dv","link-blue":"links_link-blue__1SgFW","linkBlock":"links_linkBlock__3QiPg","emoji":"links_emoji__D-vrf"};